import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: 24px;
  margin-bottom: 16px;
`;
export const ProductContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ProductImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  object-fit: cover;
`;

export const ProductName = styled.div`
  font-size: 14px;
  color: #000;
  white-space: nowrap;
`;

export const Block = styled.div`
  padding: 8px 12px;
  width: 360px;
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  top: 0;
  left: 0;
  max-height: 40vh;

  overflow: hidden;
  z-index: 3;
`;
export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 16px;
`;

export const Option = styled.div`
  color: #1a1b1c;
  font-size: 14px;
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgb(233, 237, 241);
`;
export const Label = styled.div`
  color: #1a1b1c;
  font-size: 16px;
  font-weight: 500;
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 4px;
  &.defaultImage {
    border: none;
  }
`;
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 6px;

  /* borders/default-border */
  border: 1px solid #e9edf1;
  background: #e9edf1;
`;
export const OptionsContainer = styled.div`
  overflow: auto;
  max-height: 40vh;
  padding-bottom: 12px;

  div:last-child {
    border: transparent;
  }
`;
